import React from "react";

import { Resource } from "sj-ui-toolkit/src/api/types/lessonTypes";

interface ResourcesListProps {
  resources: Resource[];
}

const ResourcesList: React.FC<ResourcesListProps> = ({ resources }) => (
  <div className="p-5">
    <ul className="list-disc list-inside">
      {resources.map(resource => (
        <li key={resource.id}>
          <a href={resource.url} target="_blank" rel="noopener noreferrer" className="link-text">
            {resource.name}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default ResourcesList;
